import React, { useState, useEffect } from "react";

const CourseProgressItem = ({ statistic, index, length }) => {
  const [progress, setProgress] = useState(0);

  const value = (statistic.progress * 100) / statistic.credits;

  useEffect(() => {
    setProgress(value > 100 ? 100 : value < 0 ? 0 : value);
  }, [value]);

  const hasProgress = statistic.progress !== 0;

  return (
    <div>
      <div className="course-progress">
        <div className="course-progress-name">
          <div 
            style={{
              backgroundColor: `${statistic.color}`,
              width: '15px',
              height: '15px', 
              borderRadius: '50%'

            }}
          ></div>
          <div 
            className={hasProgress ? "course-progress-title" : "course-progress-title-noprogress"}
            dangerouslySetInnerHTML={{ __html: statistic.courseNameShort }}
          >
          </div>
        </div>
        <div className="course-progress-container">
          <div 
            className="course-progress-bar" 
            style={{ 
              width: `${progress}%`,
              backgroundColor: `${statistic.color}`,
            }} 
          />
        </div>
      </div>
      {index < length - 1 && (
        <hr className="course-divider" />
      )}
    </div>
  );
};

export default CourseProgressItem;
